import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@customer/store/hooks';
import { useGetAssetActivityQuery } from '@customer/store/apis/assetsApi';
import { skipToken } from '@reduxjs/toolkit/query';
import { useCallback } from 'react';
import { openSidePanel, SidePanel } from '@customer/store/slices/globalSlice';
import Notes from '../../../components/data-display/notes/Notes';

export const SingleAssetActivity = () => {
  const { assetId } = useParams();
  const dispatch = useAppDispatch();

  const siteId = useAppSelector(state => state.auth.siteId);

  const request = assetId ? { assetId } : skipToken;
  const { currentData } = useGetAssetActivityQuery(request, {
    refetchOnMountOrArgChange: 10,
    skip: typeof assetId === 'undefined' || typeof siteId === 'undefined',
  });

  const onShowAddNoteForm = useCallback(() => {
    dispatch(openSidePanel({ sidePanel: SidePanel.AddAssetNote }));
  }, [dispatch]);

  return (
    <Notes
      countTrans="ActivityCount"
      noneTrans="NoActivity"
      entityId={assetId}
      notes={currentData}
      onAdd={onShowAddNoteForm}
    />
  );
};

export default SingleAssetActivity;
